module.exports = __webpack_public_path__ + "img/04_full.4da38976.jpg";